import React, {Component} from 'react';
import { connect } from 'react-redux';
import Grid from '@react/react-spectrum/Grid/js/Grid';
import GridColumn from '@react/react-spectrum/Grid/js/GridColumn';
import GridRow from '@react/react-spectrum/Grid/js/GridRow';
import Heading from '@react/react-spectrum/Heading/js/Heading';
import Button from '@react/react-spectrum/Button';
import { Translate } from 'react-redux-i18n';
import { CONTACT_HELPDESK } from '../config/constants';

class RegAnotherProg extends Component{ 
    
    render(){
        return <div>
            <Grid>  
                <GridRow>
                    <GridColumn size={[12,8,6,6]} offsetSize={[0,2,3,3]}>
                        <Heading className = "heading dark padding-3" variant="pageTitle"><Translate value="registration.problem_header"/></Heading>
                        <GridRow>
                            <GridColumn className="padding-3 font">
                            {/*The Adobe ID you've signed in with (<b>{this.props.profile.email}</b>) is already associated with another partner program : (<b>{this.props.searchData.programType}</b>). You can sign in with another Adobe ID, or contact the helpdesk to continue your registration.*/}
                            <Translate value="registration.associated_other_account" email={this.props.profile.email} program={this.props.searchData.programType} />
                            </GridColumn>
                        </GridRow>
                        <GridRow className="padding-3">
                            <GridColumn>
                                <Button variant="cta" onClick={()=>{
                                    window.adobeIMS.signOut();
                                }
                                }><Translate value="registration.sign_in"/></Button>
                                <Button variant="primary" onClick={()=>{
                                    window.open(CONTACT_HELPDESK,"_blank");
                                }
                                }><Translate value="registration.Contact Helpdesk" /></Button>
                            </GridColumn>
                        </GridRow>
                    </GridColumn>
                </GridRow>
            </Grid>
            </div>
    }
}

const mapStateToProps = (state) => ({
  profile: state.ims.userProfile,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(RegAnotherProg);